import React, { useState, useEffect } from "react";
import { Button } from 'react95'

const useAudio = (song, callback) => {
  let { url, name } = song;
  const [audio] = useState(new Audio(url));
  const [playing, setPlaying] = useState(false);

  const toggle = () => {
    setPlaying(!playing);
    callback(!playing, name);
  }

  useEffect(() => {
      playing ? audio.play() : audio.pause();
    },
    [playing]
  );

  useEffect(() => {
    audio.addEventListener('ended', () => setPlaying(false));
    return () => {
      audio.removeEventListener('ended', () => setPlaying(false));
    };
  }, []);

  return [playing, toggle];
};

const Player = ({ songs, callback, ...btnProps }) => {
  let defaultSong = songs[0]
  const [playing, toggle] = useAudio(defaultSong, callback);

  return (
    <Button {...btnProps} onClick={toggle}>{playing ? "Pause" : "Play"}</Button>
  );
};

export default Player;
